/** 1.163.0 · La apariencia en uso (la arma LookProvider; la usan el botón de sol/luna y el selector). */
import { createContext } from "react";
import type { CustomColors, LookMode, LookPref, PaletteSpec } from "@/domain/appearance";

export interface LookState {
  palette: PaletteSpec; mode: LookMode; dark: boolean;
  /** Lo que eligió el usuario (null = la del negocio). */
  user: LookPref | null;
  /** La del negocio (Configuración → General). */
  business: LookPref;
  saveUser: (p: LookPref | null) => Promise<void>;
  toggleMode: () => void;
  /** Mostrar una apariencia sin guardarla (vista previa del selector). null = volver a la guardada. */
  preview: (p: { palette: string; mode: LookMode; custom?: Partial<CustomColors> | null } | null) => void;
}
export const LookContext = createContext<LookState | null>(null);
